import React, { useMemo, useRef, useState } from "react";
import { AppBar, Toolbar, IconButton, Menu, Fab, Badge } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useEffect } from 'react';
import { Menu as MenuIcon, Person as AccountIcon, NotificationsNone as NotificationsIcon, School as SchoolIcon, SupervisorAccount as SupervisorIcon, Face as ParentIcon, EmojiPeople as TeacherIcon, Send as SendIcon, Forum as ForumIcon, Stars as UpgradeIcon } from "@material-ui/icons";

import { useHistory } from "react-router-dom";
// styles
import useStyles from "./styles";
// components
import { Typography, Button } from "../Wrappers";

import SchoolService from "../../pages/dashboard/Locality/Service/schoolService";
import ActivityService from "../../pages/dashboard/Locality/Service/activityService";
import NoteService from "../../pages/dashboard/Locality/Service/noteService";
import SocketService from "../../pages/dashboard/Locality/Service/socketService";
import StudentService from "../../pages/dashboard/Locality/Service/studentService";
import TeacherService from "../../pages/dashboard/Locality/Service/teacherService";
// context
import { useLayoutState, useLayoutDispatch, toggleSidebar } from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

const notifications = [
  { id: 0, color: "warning", message: "Check out this awesome ticket" },
  {
    id: 1,
    color: "success",
    type: "info",
    message: "What is the best way to get ...",
  },
  {
    id: 2,
    color: "secondary",
    type: "notification",
    message: "This is just a simple notification",
  },
  {
    id: 3,
    color: "primary",
    type: "e-commerce",
    message: "12 new orders has arrived today",
  },
];

export default function Header(props) {
  var classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [isMailsUnread, setIsMailsUnread] = useState(true);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [isNotificationsUnread, setIsNotificationsUnread] = useState(true);
  var [profileMenu, setProfileMenu] = useState(null);
  const [fontSize, setFontSize] = useState("2.5rem");
  const [schoolLogo, setSchoolLogo] = useState(null);
  const [schoolName, setSchoolName] = useState(null);
  const [unreadNotifCount, setUnreadNotifCount] = useState(0);
  const [adminPublishNotifications, setAdminPublishNotifications] = useState([]);
  const [adminNotifCount, setAdminNotifCount] = useState(0);
  // Chat unread count (per-note tally aggregated client-side; same source as NoteList/Note pages)
  const [chatUnreadByNote, setChatUnreadByNote] = useState({});
  const totalChatUnread = useMemo(
    () =>
      Object.values(chatUnreadByNote).reduce((a, v) => a + (Number(v) || 0), 0),
    [chatUnreadByNote],
  );
  // Parse once per render from a stable string (prevents effect refires due to new object identity)
  const userDetailsRaw = localStorage.getItem("userDetail") || "";
  const userDetails = useMemo(() => {
    try {
      return userDetailsRaw ? JSON.parse(userDetailsRaw) : {};
    } catch {
      return {};
    }
  }, [userDetailsRaw]);

  const schooleId = useMemo(() => {
    const id = userDetails?.schooleId || userDetails?.schoolId;
    return id && typeof id === "object" ? id?._id : id;
  }, [userDetails]);

  const shouldFetchSchool = useMemo(
    () =>
      Boolean(
        userDetails &&
          (userDetails.role === "SCHOOLE" ||
            userDetails.role === "TEACHER" ||
            userDetails.role === "PARENT") &&
          schooleId,
      ),
    [userDetails, schooleId],
  );

  const lastFetchedSchoolIdRef = useRef(null);
  const schoolFetchInFlightRef = useRef(false);
  const roleUpper = String(userDetails?.role || "").toUpperCase();
  const [parentStudentName, setParentStudentName] = useState("");
  const [parentProfilePending, setParentProfilePending] = useState(false);
  const [teacherDisplayName, setTeacherDisplayName] = useState("");
  const [teacherUserName, setTeacherUserName] = useState("");

  const profileUserName = useMemo(() => {
    if (!userDetails) return "";
    if (roleUpper === "PARENT") {
      return userDetails.userName || userDetails.serialNumber || userDetails.email || "";
    }
    if (roleUpper === "TEACHER") {
      return (
        teacherUserName
        || userDetails.userName
        || userDetails.mobile
        || userDetails.mobileNumber
        || userDetails.email
        || ""
      );
    }
    return userDetails.email || userDetails.userName || "";
  }, [userDetails, roleUpper, teacherUserName]);

  const displayName =
    roleUpper === "PARENT"
      ? (parentStudentName || "Student")
      : roleUpper === "TEACHER"
        ? (
            teacherDisplayName
            || userDetails?.teacherName
            || userDetails?.name
            || userDetails?.userName
            || userDetails?.mobile
            || userDetails?.email
            || "Teacher"
          )
        : (userDetails && (userDetails.name || userDetails.userName || userDetails.email)) || "";

  useEffect(() => {
    if (roleUpper !== "PARENT") return;
    const sid = userDetails?.studentId?._id || userDetails?.studentId;
    if (!sid) return;
    let alive = true;
    StudentService.getByIdStudent(sid)
      .then((res) => {
        if (!alive) return;
        const s = res?.data || res;
        const firstName = s?.firstName || "";
        const lastName = s?.lastName || "";
        const full = `${firstName} ${lastName}`.trim();
        if (full) setParentStudentName(full);
        setParentProfilePending(Boolean(s?.parentProfilePending));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [roleUpper, userDetails?.studentId]);

  // Existing teacher sessions may lack teacherName in localStorage (older login payload).
  useEffect(() => {
    if (roleUpper !== "TEACHER") {
      setTeacherDisplayName("");
      setTeacherUserName("");
      return;
    }
    const existingName = String(userDetails?.teacherName || userDetails?.name || "").trim();
    const existingUserName = String(
      userDetails?.userName || userDetails?.mobile || userDetails?.mobileNumber || userDetails?.email || "",
    ).trim();
    if (existingName) setTeacherDisplayName(existingName);
    if (existingUserName) setTeacherUserName(existingUserName);
    if (existingName && existingUserName) return;

    const teacherId = userDetails?.teacherId?._id || userDetails?.teacherId;
    if (!teacherId) return;
    let alive = true;
    TeacherService.getTeacherById(teacherId)
      .then((res) => {
        if (!alive) return;
        const teacher = res?.data || res;
        const name = String(teacher?.teacherName || "").trim();
        const mobile = String(teacher?.mobileNumber || "").trim();
        if (name) setTeacherDisplayName(name);
        if (mobile && !existingUserName) setTeacherUserName(mobile);
        try {
          const stored = JSON.parse(localStorage.getItem("userDetail") || "{}");
          localStorage.setItem(
            "userDetail",
            JSON.stringify({
              ...stored,
              ...(name ? { name, teacherName: name } : {}),
              userName: stored.userName || stored.mobile || mobile || "",
              mobile: stored.mobile || mobile || "",
            }),
          );
        } catch (e) {
          // ignore localStorage write failures
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [roleUpper, userDetails?.teacherId, userDetails?.teacherName, userDetails?.name, userDetails?.userName, userDetails?.mobile, userDetails?.mobileNumber, userDetails?.email]);

  const extractAdminPublishPayload = (row) => {
    const msg = String(row?.message || "");
    // Newer notifications append a JSON payload at the very end of message.
    // Be tolerant of \n vs \r\n and any extra text above it.
    const m = msg.match(/(\{[\s\S]*\})\s*$/);
    const jsonText = m?.[1]?.trim();
    if (!jsonText) return null;
    try {
      return JSON.parse(jsonText);
    } catch {
      return null;
    }
  };

  const getFallbackCountFromMessage = (row) => {
    const msg = String(row?.message || "");
    const payload = extractAdminPublishPayload(row);
    const payloadTotal = Number(payload?.draftActivities?.total);
    if (Number.isFinite(payloadTotal) && payloadTotal > 0) return payloadTotal;
    const m1 = msg.match(/Pending draft activities:\s*(\d+)/i);
    if (m1?.[1]) return Number(m1[1]) || 0;
    const m3 = msg.match(/Total draft activities:\s*(\d+)/i);
    if (m3?.[1]) return Number(m3[1]) || 0;
    const m2 = msg.match(/Published count:\s*(\d+)/i);
    if (m2?.[1]) return Number(m2[1]) || 0;
    return 0;
  };

  const getDisplayMessage = (row) => {
    const type = String(row?.type || "");
    const msg = String(row?.message || "");
    const payload = extractAdminPublishPayload(row);
    const summary = row?.draftActivitiesSummary || null;

    // Older records stored schedule JSON in message; keep UI clean.
    const looksLikeScheduleJson = msg.includes("nextSchedule") || msg.includes("previousSchedule") || msg.includes("{");

    if (type === "approved" && !row?.isApproved) {
      const count =
        Number(summary?.total) ||
        Number(payload?.draftActivities?.total) ||
        Number(row?.activityCount) ||
        getFallbackCountFromMessage(row) ||
        0;
      const keys = Array.isArray(summary?.publishStatusKeys) ? summary.publishStatusKeys : [];
      const keyHint = keys.length ? ` [${keys.join(", ")}]` : "";
      return `Approval required to publish activities${count ? ` (${count})` : ""}${keyHint}.`;
    }

    if (type === "notification" || row?.isApproved) {
      const published = getFallbackCountFromMessage(row);
      if (published > 0) {
        return `Approved and published successfully. Published count: ${published}`;
      }
    }

    if (looksLikeScheduleJson) {
      return row?.title ? String(row.title) : "Notification";
    }

    return msg || (row?.title ? String(row.title) : "Notification");
  };
  
  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 600 ? "1.75rem" : "2.5rem");
    };
    window.addEventListener("resize", handleResize);
    handleResize(); 
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (String(userDetails?.role || "").toUpperCase() !== "SCHOOLE") return;
    let alive = true;

    const fetchAdminNotifications = async () => {
      try {
        const res = await ActivityService.listAdminPublishNotifications();
        const data = res?.data || res;
        const items = Array.isArray(data?.items) ? data.items : [];
        if (!alive) return;
        setAdminPublishNotifications(items);
        // count only pending approvals
        const pending = items.filter((x) => x?.type === "approved" && !x?.isApproved);
        setAdminNotifCount(pending.length);
      } catch {
        if (!alive) return;
        setAdminPublishNotifications([]);
        setAdminNotifCount(0);
      }
    };

    fetchAdminNotifications();
    const t = setInterval(fetchAdminNotifications, 30000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, [userDetails?.role]);

  const approvePublish = async (row) => {
    if (!row?._id) return;
    try {
      await ActivityService.approvePublish(row._id);
      // refresh
      const res = await ActivityService.listAdminPublishNotifications();
      const data = res?.data || res;
      const items = Array.isArray(data?.items) ? data.items : [];
      setAdminPublishNotifications(items);
      const pending = items.filter((x) => x?.type === "approved" && !x?.isApproved);
      setAdminNotifCount(pending.length);
    } catch (e) {
      alert(e?.response?.data?.message || "Failed to approve publishing.");
    }
  };

  useEffect(() => {
    // Fetch school logo and name for schoole, teacher, and parent roles
    // Guarded to prevent duplicate fetches on re-renders / StrictMode.
    if (!shouldFetchSchool) return;
    if (schoolFetchInFlightRef.current) return;
    if (lastFetchedSchoolIdRef.current === String(schooleId)) return;

    schoolFetchInFlightRef.current = true;
    lastFetchedSchoolIdRef.current = String(schooleId);

    SchoolService.getSchooleRegistrationById(schooleId)
      .then((res) => {
        const data = res?.data || res;
        const logo = data?.logo ? String(data.logo).trim() : "";
        const name = data?.schooleName ? String(data.schooleName).trim() : "";
        setSchoolLogo(logo || null);
        setSchoolName(name || null);
      })
      .catch((err) => {
        console.error("Error fetching school details:", err);
      })
      .finally(() => {
        schoolFetchInFlightRef.current = false;
      });
  }, [shouldFetchSchool, schooleId]);

  useEffect(() => {
    const readCount = () => {
      const raw = localStorage.getItem("parent_notifications_unread") || "0";
      const n = Number(raw);
      setUnreadNotifCount(Number.isFinite(n) ? n : 0);
    };
    readCount();
    const onCustom = () => readCount();
    window.addEventListener("parent-notifications-unread-changed", onCustom);
    window.addEventListener("storage", onCustom);
    return () => {
      window.removeEventListener("parent-notifications-unread-changed", onCustom);
      window.removeEventListener("storage", onCustom);
    };
  }, []);

  // Global chat unread badge for any logged-in chat-enabled user.
  useEffect(() => {
    const role = String(userDetails?.role || "").toUpperCase();
    // SUPERADMIN: don't show message counts in header.
    if (role === "SUPERADMIN" || role === "TEACHER") return;
    if (!["PARENT", "SCHOOLE"].includes(role)) return;

    let alive = true;

    SocketService.initializeSocket();
    NoteService.getUnreadSummary()
      .then((res) => {
        if (!alive) return;
        const data = res?.data || res || {};
        const normalized = {};
        Object.entries(data.byNoteId || {}).forEach(([noteId, count]) => {
          const n = Number(count) || 0;
          if (n > 0) normalized[String(noteId)] = n;
        });
        setChatUnreadByNote(normalized);
      })
      .catch((err) => console.error("Header: unread summary failed", err));

    const offUpdate = SocketService.onUnreadUpdate((payload) => {
      const noteId = payload?.noteId ? String(payload.noteId) : '';
      if (!noteId) return;

      if (payload.unreadCount != null) {
        const count = Number(payload.unreadCount) || 0;
        setChatUnreadByNote((prev) => {
          const next = { ...prev };
          if (count <= 0) delete next[noteId];
          else next[noteId] = count;
          return next;
        });
        return;
      }

      setChatUnreadByNote((prev) => ({
        ...prev,
        [noteId]: (Number(prev[noteId]) || 0) + (Number(payload.increment) || 1),
      }));
    });
    const offCleared = SocketService.onUnreadCleared((payload) => {
      const noteId = payload?.noteId ? String(payload.noteId) : '';
      if (!noteId) return;
      setChatUnreadByNote((prev) => {
        const next = { ...prev };
        delete next[noteId];
        return next;
      });
    });

    return () => {
      alive = false;
      if (typeof offUpdate === "function") offUpdate();
      if (typeof offCleared === "function") offCleared();
    };
  }, [userDetails?.role, userDetails?._id]);

  const openChatPage = () => {
    const role = String(userDetails?.role || "").toUpperCase();
    if (role === "PARENT") history.push("/app/note");
    else history.push("/app/notelist");
  };

  const openParentNotifications = () => {
    try {
      localStorage.setItem("parent_notifications_unread", "0");
      window.dispatchEvent(new Event("parent-notifications-unread-changed"));
    } catch {
      // ignore
    }
    history.push("/app/parent-notifications");
  };

  // style={{ backgroundColor: 'rgb(255, 92, 147)', color: 'white' }}
  return (
<AppBar
      position="fixed"
      className={classes.appBar}
      style={{ backgroundColor: "#f5f5f5", border: "none", height: "60px" }}
    >    
    
      <Toolbar className={classes.toolbar}>
      {/* <button   onClick={() => toggleSidebar(layoutDispatch)}>click</button> */}
      {/* <div className={classes.mobileBackButton}>
          <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
            <MenuIcon /> 
          </IconButton>
        </div> */}
        <IconButton
          edge="start"
          aria-label={layoutState.isSidebarOpened ? "Collapse menu" : "Expand menu"}
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classes.headerIconButton}
        >
          <MenuIcon style={{ fontSize: 22, color: "#1a1a1a" }} />
        </IconButton>
      <div className={classes.logoContainer}>
          <img
            src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
            alt="logo"
            className={classes.logoImage} style={{ height: isMobile ? "30px" : "38px", width: "auto" }}
          />
          
        </div>

        {/* Centered school logo + name (Montestory logo stays on the left) */}
        {!isMobile && (schoolName || schoolLogo) && (
          <div className={classes.centerSchoolBrand} title={schoolName || ""}>
            {schoolLogo ? (
              <img
                src={schoolLogo}
                alt={schoolName ? `${schoolName} logo` : "School logo"}
                className={classes.centerSchoolLogo}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            ) : null}
            {schoolName ? (
              <span className={classes.centerSchoolName}>{schoolName}</span>
            ) : null}
          </div>
        )}
       {/* <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
        >

          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton> */}
        {/* <Typography variant="h6" weight="medium" className={classes.logotype} style={{ fontSize:"calc(2.1rem)", fontWeight:"400", }}>
        <img
            src="https://artistimages.blob.core.windows.net/montestory/logo 2.svg"
            alt="logo"
            style={{ width: "85px", height: "auto", marginTop: "8px" }}
          /> 
        </Typography> */}
       
        <div className={classes.grow} />


        {roleUpper === "SCHOOLE" &&
          (isMobile ? (
            // Icon-only on phones; the text button pushed the profile icon off-screen.
            <IconButton
              aria-label="Upgrade Plan"
              title="Upgrade Plan"
              onClick={() => history.push("/app/upgrade-plan")}
              className={classes.headerMenuButton}
            >
              <UpgradeIcon style={{ fontSize: 20, color: "#1a1a1a" }} />
            </IconButton>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.upgradePlanBtn}
              onClick={() => history.push("/app/upgrade-plan")}
            >
              Upgrade Plan
            </Button>
          ))}

        
        {/* <Button component={Link} href="https://flatlogic.com/templates/react-material-admin-full" variant={"outlined"} color={"secondary"} className={classes.purchaseBtn}>Unlock full version</Button> */}
        
        {/* <IconButton
          color="inherit"
          aria-haspopup="true"
          aria-controls="mail-menu"
          onClick={e => {
            setNotificationsMenu(e.currentTarget);
            setIsNotificationsUnread(false);
          }}
          className={classes.headerMenuButton}
        >
         
        </IconButton> */}
        {/* School name is now centered; logo/name block removed from right side */}

        {["PARENT", "SCHOOLE"].includes(String(userDetails?.role || "").toUpperCase()) && (
          <IconButton
            aria-label="messages"
            onClick={openChatPage}
            className={classes.headerMenuButton}
          >
            <Badge
              badgeContent={totalChatUnread > 0 ? totalChatUnread : 0}
              color="error"
              overlap="rectangular"
              invisible={totalChatUnread <= 0}
              max={99}
            >
              <ForumIcon style={{ fontSize: 20, color: "#1a1a1a" }} />
            </Badge>
          </IconButton>
        )}

        {String(userDetails?.role || "").toUpperCase() === "PARENT" && (
          <IconButton
            aria-label="notifications"
            onClick={openParentNotifications}
            className={classes.headerMenuButton}
          >
            <Badge
              badgeContent={unreadNotifCount > 0 ? unreadNotifCount : 0}
              color="secondary"
              overlap="rectangular"
              invisible={unreadNotifCount <= 0}
            >
              <NotificationsIcon style={{ fontSize: 20, color: "#1a1a1a" }} />
            </Badge>
          </IconButton>
        )}

        {String(userDetails?.role || "").toUpperCase() === "SCHOOLE" && (
          <IconButton
            aria-label="publish approvals"
            onClick={(e) => setNotificationsMenu(e.currentTarget)}
            className={classes.headerMenuButton}
          >
            <Badge
              badgeContent={adminNotifCount > 0 ? adminNotifCount : 0}
              color="secondary"
              overlap="rectangular"
              invisible={adminNotifCount <= 0}
            >
              <NotificationsIcon style={{ fontSize: 20, color: "#1a1a1a" }} />
            </Badge>
          </IconButton>
        )}

        <IconButton
          aria-label="Account menu"
          aria-haspopup="true"
          aria-controls="profile-menu"
          color="inherit"
          className={classes.profileMenuButton}
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon style={{ fontSize: 22, color: "#fff" }} />
        </IconButton>
        <Menu 
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              New Messages
            </Typography>
            <Typography 
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} New Messages
            </Typography>
          </div>
          {/* {messages.map(message => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))} */}
          <Fab 
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        <Menu
          id="admin-publish-notifications-menu"
          open={Boolean(notificationsMenu)}
          anchorEl={notificationsMenu}
          onClose={() => setNotificationsMenu(null)}
          className={classes.headerMenu}
          disableAutoFocusItem
        >
          <div style={{ padding: 12, width: 460, maxWidth: "92vw" }}>
            <Typography variant="h4" weight="medium">
              Notifications
            </Typography>
            <Typography color="text" colorBrightness="secondary" style={{ marginTop: 4, marginBottom: 10 }}>
              Publish approvals and activity publish logs.
            </Typography>

            {adminPublishNotifications.length === 0 ? (
              <Typography color="text" colorBrightness="secondary">
                No notifications yet.
              </Typography>
            ) : (
              adminPublishNotifications.map((row) => {
                const payload = extractAdminPublishPayload(row);
                const summary = row?.draftActivitiesSummary || null;
                const isPendingApproval = row?.type === "approved" && !row?.isApproved;
                const isPublishedLog = row?.type === "notification" || Boolean(row?.isApproved);

                // Pending: live draft count for selected publish statuses.
                // Published logs: use Published count (do not reuse draft totals).
                const total = isPendingApproval
                  ? (
                      Number(summary?.total) ||
                      Number(payload?.draftActivities?.total) ||
                      Number(row?.activityCount) ||
                      getFallbackCountFromMessage(row) ||
                      0
                    )
                  : (
                      getFallbackCountFromMessage(row) ||
                      Number(row?.activityCount) ||
                      0
                    );

                const breakdown = isPendingApproval
                  ? (
                      summary?.byClassAndSection ||
                      payload?.draftActivities?.byClassAndSection ||
                      null
                    )
                  : null;

                return (
                  <div
                    key={row._id}
                    style={{
                      border: "1px solid rgba(15, 59, 98, 0.12)",
                      borderRadius: 12,
                      padding: 10,
                      marginBottom: 10,
                      background: "#fff",
                    }}
                  >
                    <Typography style={{ fontWeight: 800, color: "#0f3b62" }}>
                      {row.title || (row.type === "approved" ? "Approval required" : "Notification")}
                    </Typography>
                    <Typography color="text" colorBrightness="secondary" style={{ marginTop: 6 }}>
                      {getDisplayMessage(row)}
                    </Typography>

                    <div style={{ marginTop: 8 }}>
                      <Typography style={{ fontSize: 13, fontWeight: 700, color: "#0f3b62" }}>
                        {isPublishedLog ? "Published activities" : "Activities"}: {total}
                      </Typography>

                      {Array.isArray(breakdown) && breakdown.length > 0 ? (
                        <div style={{ marginTop: 6 }}>
                          {breakdown.map((b, idx) => {
                            const className = b?.className || "—";
                            const sectionName = b?.sectionLabel || b?.sectionName || "No section";
                            const count = Number(b?.draftCount ?? b?.count) || 0;
                            const dFrom = b?.dateFrom ? new Date(b.dateFrom).toLocaleDateString() : null;
                            const dTo = b?.dateTo ? new Date(b.dateTo).toLocaleDateString() : null;
                            const singleDate = dTo || dFrom || null;
                            return (
                              <div
                                key={`${row._id}-bd-nice-${idx}`}
                                style={{
                                  padding: "6px 8px",
                                  borderRadius: 10,
                                  border: "1px solid rgba(15, 59, 98, 0.10)",
                                  background: "rgba(15, 59, 98, 0.03)",
                                  marginTop: idx === 0 ? 0 : 6,
                                }}
                              >
                                <Typography style={{ fontSize: 13, fontWeight: 800, color: "#0f3b62" }}>
                                  {className}
                                </Typography>
                                <Typography color="text" colorBrightness="secondary" style={{ fontSize: 12, marginTop: 2 }}>
                                  {sectionName} • {count} Activities
                                </Typography>
                                {singleDate && (
                                  <Typography color="text" colorBrightness="secondary" style={{ fontSize: 11, marginTop: 2 }}>
                                    {singleDate ? `Date: ${singleDate}` : null}
                                  </Typography>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : Array.isArray(row?.activityBreakdown) && row.activityBreakdown.length > 0 && isPendingApproval ? (
                        <div style={{ marginTop: 6 }}>
                          {row.activityBreakdown.map((b, idx) => {
                          const className = b?.className || "—";
                          const sectionName = b?.sectionId ? b?.sectionName || "—" : "No section";
                          const count = Number(b?.count) || 0;
                          return (
                            <Typography
                              key={`${row._id}-bd-${idx}`}
                              color="text"
                              colorBrightness="secondary"
                              style={{ fontSize: 12, marginTop: 2 }}
                            >
                              {className} | {sectionName} • {count} Activities
                            </Typography>
                          );
                          })}
                        </div>
                      ) : (
                        <Typography color="text" colorBrightness="secondary" style={{ fontSize: 12, marginTop: 4 }}>
                          {isPublishedLog
                            ? "Published to parents for the selected activity statuses."
                            : "This notification applies to selected activity statuses for this school."}
                        </Typography>
                      )}
                    </div>

                    {row.type === "approved" && !row.isApproved && (
                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                        <Button size="small" color="primary" variant="contained" onClick={() => approvePublish(row)}>
                          Approve
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </Menu>
        <Menu 
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {displayName}
            </Typography>
            {userDetails.role && (
              <div style={{ display: "flex", alignItems: "center", marginTop: 2, gap: 6 }}>
                {String(userDetails.role).toUpperCase() === "SCHOOLE" && (
                  <SchoolIcon style={{ fontSize: 18, color: "#1d4ed8" }} />
                )}
                {String(userDetails.role).toUpperCase() === "SUPERADMIN" && (
                  <SupervisorIcon style={{ fontSize: 18, color: "#b91c1c" }} />
                )}
                {String(userDetails.role).toUpperCase() === "TEACHER" && (
                  <TeacherIcon style={{ fontSize: 18, color: "#15803d" }} />
                )}
                {String(userDetails.role).toUpperCase() === "PARENT" && (
                  <ParentIcon style={{ fontSize: 18, color: "#92400e" }} />
                )}
                <Typography
                  variant="subtitle2"
                  style={{ color: "#64748b", fontWeight: 600 }}
                >
                  {String(userDetails.role).toLowerCase() === "schoole"
                    ? "School Admin"
                    : String(userDetails.role).charAt(0).toUpperCase() + String(userDetails.role).slice(1).toLowerCase()}
                </Typography>
              </div>
            )}
            {profileUserName ? (
              <Typography
                className={classes.profileMenuLink}
                component="span"
                color="primary"
                style={{ display: "block", marginTop: 4 }}
              >
                {profileUserName}
              </Typography>
            ) : null}
          </div>
          {/* <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Profile
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Tasks
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Messages
          </MenuItem> */}
          {roleUpper === "PARENT" ? (
            <div className={classes.profileMenuUser}>
              <Typography
                className={classes.profileMenuLink}
                color="primary"
                style={{ cursor: "pointer", fontWeight: 600 }}
                onClick={() => {
                  setProfileMenu(null);
                  history.push("/app/parent-student-profile");
                }}
              >
                {parentProfilePending ? "Add Profile" : "Edit Profile"}
              </Typography>
            </div>
          ) : null}
          <div className={classes.profileMenuUser}>
            <Typography 
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
